import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TealiumComponent } from './tealium.component';

@NgModule({
  declarations: [TealiumComponent],
  imports: [CommonModule],
  exports: [TealiumComponent],
})
export class TealiumModule {}
